import React from 'react';

const ThunderIcon: React.FC = () => (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.883 1.55518H6.83242C6.37667 1.55518 5.97857 1.86334 5.86434 2.30455L4.25988 8.50193C4.09596 9.13508 4.57394 9.75256 5.22796 9.75256L7.20498 9.75256L6.13915 17.7168C6.01371 18.6542 7.13917 19.2258 7.8221 18.5716L16.274 10.4747C16.9248 9.85118 16.4835 8.75256 15.5822 8.75256H12.983L14.8369 2.85508L14.36 2.70513L14.8369 2.85508C15.0395 2.21081 14.5583 1.55518 13.883 1.55518Z"
      fill="url(#paint0_linear_2530_50023)"
      stroke="url(#paint1_linear_2530_50023)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2530_50023"
        x1="10.7045"
        y1="2.05518"
        x2="10.7045"
        y2="19.198"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FACA59" />
        <stop offset="0.514934" stopColor="#F99D1B" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2530_50023"
        x1="10.7045"
        y1="2.05518"
        x2="10.7045"
        y2="19.198"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
    </defs>
  </svg>
);

export default ThunderIcon;
